export const CONTENT_EXCEPTIONS = [
  'AnnotationImageCard',
  'TopPosts',
  'TopLikedPosts',
  'NewPosts',
  'TopPostsByFollowers',
  'TopPostsByInteractions',
  'PropTopCommentsPosts',
  'TimelineProprietaryPosts',
  'PropTopPosts',
];

export const PIECHART_EXCEPTIONS = [
  'ChannelPieChart',
  'DevicePieChart',
  'GenderPieChart',
  'PropChannelPieChart',
  'PropSentimentPie',
  'BlipEventTrackPieChart',
];
